// Monitoring-readiness validation run by the EXR mock backend (ExrMockInterceptor) when a season is transitioned to
// Monitoring. In the real system this check lives inside the backend transition endpoint, not on the client.
// TODO: Replace with the real EXR backend validation once the EXR season-state transition endpoint exists. (GMTEC-20689)
// Each entry pairs the season-settings field with its label translation key, so the rejected transition can list the
// unmet requirements back to the admin. The labels mirror the EXR season-settings config.
const EXR_MONITORING_REQUIRED_FIELDS: { settingsKey: string; label: string }[] = [
  { settingsKey: 'fxDateAt', label: 'season-mgmt.special-payment.season-setting.fx-date' },
  { settingsKey: 'rewardDateAt', label: 'season-mgmt.special-payment.season-setting.reward-date' },
  { settingsKey: 'exrCAndBRuleSetId', label: 'season-mgmt.exceptional-recognition.season-setting.cand-b-rule-set' },
  {
    settingsKey: 'cAndBCreationMailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.cand-b-creation-mail-template'
  },
  {
    settingsKey: 'nMinus2MailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.nminus2-mail-template'
  },
  { settingsKey: 'hoHMailTemplateId', label: 'season-mgmt.exceptional-recognition.season-setting.hoh-mail-template' },
  {
    settingsKey: 'globalHrBpMailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.global-hr-bp-mail-template'
  },
  {
    settingsKey: 'cAndBApproverMailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.cand-b-approver-mail-template'
  },
  {
    settingsKey: 'headOfHrMailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.head-of-hr-mail-template'
  },
  {
    settingsKey: 'headOfMaMailTemplateId',
    label: 'season-mgmt.exceptional-recognition.season-setting.head-of-ma-mail-template'
  }
];

// Returns the labels of the season-level Monitoring requirements that are not yet satisfied. An empty array means the
// season meets the season-level requirements to move to Monitoring.
export function getExrMonitoringMissingRequirements(settings: Record<string, unknown> | null | undefined): string[] {
  const values = settings ?? {};

  // TODO: the following plan-dependent rules can't be evaluated until EXR plan management exists in the admin app (no
  // plan UI/model fields yet). Add them once plans are available: (GMTEC-20689)
  //  - at least one non-excluded plan must exist
  //  - each non-excluded Sign-On Bonus / Exceptional Recognition plan must have category, compensation type, workflow,
  //    letter template and task templates
  //  - each non-excluded Transformation Incentive plan must have category and compensation type
  //  - the season-level TI fields (transformationIncentiveHeadOfHrEmployeeId, cfoApprovalThresholdAmount,
  //    transformationIncentiveHeadOfMaEmployeeId) are required only when a non-excluded Transformation Incentive plan exists
  return EXR_MONITORING_REQUIRED_FIELDS.filter(({ settingsKey }) => {
    const value = values[settingsKey];
    return value == null || value === '';
  }).map(({ label }) => label);
}
